"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _theme = require("../../../theme");
/* eslint-disable quote-props */

var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    menuItemHover: {
      display: 'flex',
      fontFamily: typography.fontFamily,
      fontSize: '12px',
      padding: '16px 20px 16px 20px',
      minWidth: 200,
      color: '#333333',
      '& .MuiTouchRipple-root': {
        display: 'none'
      }
    },
    menuItem: {
      display: 'flex',
      fontFamily: typography.fontFamily,
      fontSize: '12px',
      padding: '16px 20px 16px 20px',
      minWidth: 200,
      color: '#333333',
      backgroundColor: 'transparent !important',
      '& .MuiTouchRipple-root': {
        display: 'none'
      },
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    underline: {
      borderBottom: '1px solid rgba(112, 112, 112, 0.2)'
    },
    iconWrapper: {
      width: 80,
      display: 'flex',
      justifyContent: 'flex-end',
      marginLeft: 'auto'
    }
  };
}, {
  name: 'MenuDropdownItem'
});
var _default = useStyles;
exports["default"] = _default;